import React, { useEffect } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

const TOOLTIP_MAP = {
  "ql-bold": "Bold",
  "ql-italic": "Italic",
  "ql-underline": "Underline",
  "ql-strike": "Strikethrough",
  'ql-script[value="sub"]': "Subscript",
  'ql-script[value="super"]': "Superscript",
  'ql-list[value="ordered"]': "Numbered List",
  'ql-list[value="bullet"]': "Bullet List",
  "ql-code-block": "Code Block",
  "ql-blockquote": "Block Quote",
  'ql-header[value="1"]': "Heading 1",
  'ql-header[value="2"]': "Heading 2",
  'ql-header[value="3"]': "Heading 3",
  'ql-header[value="4"]': "Heading 4",
  'ql-header[value="5"]': "Heading 5",
  'ql-header[value="6"]': "Heading 6",
  "ql-header": "Normal Text",
  "ql-link": "Insert Link",
  "ql-image": "Insert Image",
};

export default function EditorViewer({
  readOnly = false,
  value = "",
  setValue,
   code = false, 
}) {
  const theme = "snow";

  const editModules = {
    toolbar: [
      ["code-block"],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
    ],
  };

  const readOnlyModules = {
    toolbar: false,
  };

  const placeholder = "Write here...";
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "script",
    "indent",
    "link",
    "image",
    "code-block",
    "size",
  ];

  const { quill, quillRef } = useQuill({
    theme,
    placeholder,
    modules: readOnly ? readOnlyModules : editModules,
    formats,
    readOnly,
  });

  const addToolbarTooltips = (quill) => {
    const toolbar = quill.container.previousSibling;
    if (!toolbar) return;

    Object.entries(TOOLTIP_MAP).forEach(([selector, title]) => {
      const btn =
        toolbar.querySelector(`.${selector}`) ||
        toolbar.querySelector(`button.${selector}`);
      if (btn && !btn.getAttribute("title")) {
        btn.setAttribute("title", title);
      }
    });
  };



  // useEffect(() => {
  //   if (quill) {
  //     addToolbarTooltips(quill);

  //     if (!readOnly) {
  //       quill.on("text-change", () => {
  //         setValue(quill.root.innerHTML);
  //       });
  //     }
  //   }
  // }, [quill, readOnly, setValue]);
useEffect(() => {
  if (quill) {
    addToolbarTooltips(quill);

    // If code prop is true, select code block and disable changing it
    if (code) {
      const range = quill.getSelection();
      if (range) {
        quill.format("code-block", true); // select code block
      } else {
        quill.once("selection-change", () => {
          quill.format("code-block", true);
        });
      }

      // disable toolbar button for code block
      const toolbar = quill.container.previousSibling;
      const codeBtn = toolbar.querySelector(".ql-code-block");
      if (codeBtn) codeBtn.setAttribute("disabled", true);
    }

    if (!readOnly) {
      quill.on("text-change", () => {
        setValue(quill.root.innerHTML);
      });
    }
  }
}, [quill, readOnly, setValue, code]);

  // useEffect(() => {
  //   if (quill && value) {
  //     quill.clipboard.dangerouslyPasteHTML(value);
  //   }
  // }, [quill]);
useEffect(() => {
  if (quill && value) {
    quill.clipboard.dangerouslyPasteHTML(value);

    // Move cursor to the end
    const length = quill.getLength(); // get total length
    quill.setSelection(length, 0);    // set cursor at end
  }
}, [quill, value]);

  return (
   <div className="code-textarea  overflow-x-hidden">
  <div ref={quillRef} style={{minHeight:'200px',maxHeight:'400px',borderRadius:'0px',overflow:'auto'}} />
</div>

  );
}
